import { lazy } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { RootState } from 'storage/store';
import { domainConfig } from 'utils/domainConfig';

const Statements = lazy(() => import('components/Statements/Statements'));

const StatementsGuard = () => {
  const { isRo } = domainConfig;
  const statements = useSelector((state: RootState) => state.statements);
  if (!statements || isRo) return null;

  const notAccepted = statements?.statements.filter(
    (statement) => !statement.accepted
  );
  if (isEmpty(notAccepted)) {
    return null;
  }
  return <Statements notAccepted={notAccepted} />;
};

export default StatementsGuard;
